export default __webpack_public_path__ + "static/media/ocean.ad276da5.mp4";